// extracted by mini-css-extract-plugin
export default {"Graphic":"curveGraphic_Graphic__0-cjh"};